<template>
  <div class="items">
    <div class="item" v-for="(product, i) in $props.products" :key="i">
      <img
        class="img-music"
        :src="require(`@/assets/pages/${product.img}`)"
        :alt="product.text"
      />
      <div>{{ product.text }}</div>
      <div v-if="product.price">~€{{ product.price }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductsRow",
  props: {
    products: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.items {
  margin-top: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  .item {
    min-width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 10px 5px 10px;

    img {
      height: 150px;
      margin-bottom: 20px;
    }
    div {
      text-align: center;
    }
  }
}
@media only screen and (max-width: $screen-md) {
  .items {
    margin-bottom: 0px;
    margin-top: 20px;
  }
}
</style>
